import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 4L13 10L7 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgArrowRight;
